<template>
  <div class="store-product-sort">
    <!-- <el-button class="sort-btn-time" :class="{'selected': [TIME_ASC,TIME_DESC].includes(sortType)}" @click="onSortTypeClick(timeSortValue)">
      <span class="ml-1">积分</span><el-icon :class="{'unselected': TIME_ASC === sortType, 'el-icon-sort-down': true}"></el-icon><el-icon :class="{'unselected': TIME_DESC === sortType, 'el-icon-sort-up': true}"></el-icon>
    </el-button>
    <el-button class="sort-btn-price" :class="{'selected': [PRICE_ASC,PRICE_DESC].includes(sortType)}" @click="onSortTypeClick(priceSortValue)">
      <span class="ml-1">价格</span><el-icon :class="{'unselected': PRICE_ASC === sortType, 'el-icon-sort-down': true}"></el-icon><el-icon :class="{'unselected': PRICE_DESC === sortType, 'el-icon-sort-up': true}"></el-icon>
    </el-button> -->
    <div class="price-range-wrapper">
      <div class="search-text">
        <i class="el-icon-coin"></i>
        <span>{{ $t('PointsMall.IntegratingRange') }}</span>
        <el-divider direction="vertical"></el-divider>
      </div>
      <div class="range-wrap">
        <span
          v-for="(item, index) in rangeList"
          :key="index"
          :class="item.isSelect ? 'range-item selected' : 'range-item'"
          @click="searchRange(item.range, index)"
          >{{ item.label }}</span
        >
      </div>
      <!-- :min="PRICE_MIN"
        :max="PRICE_MAX" -->
      <el-input-number
        v-model="startPrice"
        class="price-start"
        :placeholder="$t('PointsMall.LowestPoints')"
        :controls="false"
        :precision="PRECISION"
      />
      <div class="separator">-</div>
      <el-input-number
        v-model="endPrice"
        class="price-end"
        :placeholder="$t('PointsMall.HighestPoints')"
        :controls="false"
        :precision="PRECISION"
      />
      <a-config-provider :auto-insert-space-in-button="false">
        <el-button
          size="small"
          type="primary"
          class="btn-price-range"
          style="margin-left: 10px"
          icon="el-icon-search"
          @click="onPriceRangeClick"
        >
          {{ $t('PointsMall.Inquire') }}
        </el-button>
      </a-config-provider>
      <a-config-provider :auto-insert-space-in-button="false">
        <el-button
          size="small"
          class="btn-price-range"
          icon="el-icon-refresh-right"
          @click="reset"
        >
          {{ $t('PointsMall.ClearUp') }}
        </el-button>
      </a-config-provider>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import i18n from '@/i18n/i18n'
export default {
  name: 'StoreProductSort',
  props: {
    showOwnCheckbox: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      PRECISION: 0,
      PRICE_MIN: 0,
      PRICE_MAX: 99999999,
      TIME_ASC: '1',
      TIME_DESC: '2',
      timeSortValue: '1',
      PRICE_ASC: '3',
      PRICE_DESC: '4',
      sortType: '1',
      priceSortValue: '3',
      startPrice: undefined,
      endPrice: undefined,
      isSelfOp: false,
      rangeList: [{
        label: i18n.t('PointsMall.All'),
        range: 'all',
        isSelect: true
      },
      {
        label: '0-100,000 ' + i18n.t('PointsMall.Points'),
        range: '0-100,000',
        isSelect: false
      },
      {
        label: '100,000-500,000 ' + i18n.t('PointsMall.Points'),
        range: '100,000-500,000',
        isSelect: false
      },
      {
        label: i18n.t('PointsMall.Over'),
        range: '500,000-999,999,999',
        isSelect: false
      }]
    }
  },
  watch: {
    '$route.query': {
      handler(newVal) {
        if (!newVal.psort) {
          this.sortType = this.DEFAULT
        }
      }
    }
  },
  created() {
    this.onCheckboxChange = throttle(this.onCheckboxChange, 300)
  },
  mounted() {
    const { query } = this.$route
    this.sortType = query.psort || this.DEFAULT
    this.isSelfOp = query.pself === '1'
    this.setPriceRange(query.prange)
  },
  methods: {
    resetSortValues() {
      this.sortType = this.DEFAULT
      this.timeSortValue = this.TIME_ASC
      this.priceSortValue = this.PRICE_ASC
      this.startPrice = undefined
      this.endPrice = undefined
      this.isSelfOp = false
    },
    setPriceRange(range) {
      // range格式 int-int
      if (!range || !/^\d+-\d+$/.test(String(range))) {
        this.startPrice = undefined
        this.endPrice = undefined
      }
      const rangeStr = String(range)
      const [start, end] = rangeStr.split('-')
      this.startPrice = Number(start) || undefined
      this.endPrice = Number(end) || undefined
    },
    onSortTypeClick(type) {
      console.log('onRadioClick', type)
      if (type === this.sortType) {
        return
      }
      this.sortType = type
      this.priceSortValue = type === this.PRICE_ASC ? this.PRICE_DESC : this.PRICE_ASC
      this.timeSortValue = type === this.TIME_ASC ? this.TIME_DESC : this.TIME_ASC
      this.$emit('searchList', { psort: type })
    },
    checkEmpty(value) {
      return ['', null, undefined, ' '].includes(value)
    },
    reset() {
      this.rangeList.forEach(item => {
        item.isSelect = false
      })
      this.startPrice = undefined
      this.endPrice = undefined
      this.$emit('searchList', { psort: this.sortType, prange: undefined })
    },
    searchRange(priceRange, index) {
      this.rangeList.forEach((item, idx) => {
        if (idx === index) {
          this.rangeList[idx].isSelect = true
        } else {
          this.rangeList[idx].isSelect = false
        }
      })
      this.startPrice = undefined
      this.endPrice = undefined
      if (priceRange === 'all') {
        this.$emit('searchList', { psort: this.sortType, prange: undefined })
      } else {
        this.$emit('searchList', { psort: this.sortType, prange: priceRange })
      }
    },
    searchAll() {
      this.startPrice = undefined
      this.endPrice = undefined
      this.$emit('searchList', { psort: this.sortType, prange: undefined })
    },
    onPriceRangeClick() {
      console.log(this.startPrice, this.endPrice)
      if (this.checkEmpty(this.startPrice)) {
        this.startPrice = undefined
      }
      if (this.checkEmpty(this.endPrice)) {
        this.endPrice = undefined
      }
      this.rangeList.forEach(item => {
        item.isSelect = false
      })
      if (this.checkEmpty(this.startPrice) && this.checkEmpty(this.endPrice)) { // 两个值都不存在
        // if (this.$route.query.prange) {
        //   this.$emit('searchList', { psort: type, prange: undefined })
        // }
        this.$emit('searchList', { psort: this.sortType, prange: undefined })
        return
      }
      if (!this.checkEmpty(this.startPrice) && !this.checkEmpty(this.endPrice)) { // 两个值都存在
        if (this.startPrice > this.endPrice) {
          const temp = Number(this.startPrice)
          this.startPrice = Number(this.endPrice)
          this.endPrice = temp
        }
        // 不刷新无变化区间
        const priceRange = `${this.startPrice || 0}-${this.endPrice || 0}`
        // if (priceRange === this.$route.query.prange) { return }
        this.$emit('searchList', { psort: this.sortType, prange: priceRange })
      }
    },
    onCheckboxChange() {
      this.isSelfOp = !this.isSelfOp
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pself: this.isSelfOp ? '1' : undefined
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.store-product-sort {
  // height: 36px;
  // margin: 30px 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  [class^='sort-btn-'] {
    height: 36px;
    width: 92px;
    font-size: 12px;
    border-radius: 6px;
    box-shadow: none;
    text-shadow: none;
    transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
    // @apply mr-4 text-gray-800 bg-gray-50 border-gray-100;
    &:hover {
      // @apply text-mwblue-light;
    }
    &.selected {
      background: #51abc3;
      color: white;
      // @apply text-white bg-mwblue-light border-mwblue-light;
    }
  }
  .sort-btn-price,
  .sort-btn-time {
    .el-icon-sort-up,
    .el-icon-sort-down {
      // @apply text-sm;
      &.unselected {
        // @apply text-mwblue-light;
        color: yellow;
      }
    }
  }
  .price-range-wrapper {
    height: 36px;
    border-radius: 6px;
    font-size: 12px;
    position: relative;
    display: flex;
    // justify-content: flex-start;
    align-items: center;
    margin-left: 10px;
    .search-text {
      margin-right: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #111827;
      .el-icon-coin {
        margin-right: 4px;
      }
      span,
      .el-icon-coin {
        vertical-align: middle;
      }
    }
    .range-wrap {
      .range-item {
        color: #111827;
        padding: 8px 10px;
        border-radius: 5px;
        margin-right: 6px;
        cursor: pointer;
      }
      .range-item.selected {
        background: #51abc3;
        color: white;
      }
    }
    .el-input-number.price-start,
    .el-input-number.price-end {
      width: 150px;
    }
    // @apply relative pr-16 mr-4 flex items-center border bg-gray-50 border-gray-100;
    .ant-input-number {
      height: 32px;
      border: none;
      display: flex;
      // justify-content: flex-start;
      align-items: center;
      // @apply flex items-center bg-gray-50;
    }
    .ant-input-number-focused {
      box-shadow: none;
    }
    .ant-input-number:hover,
    .ant-input-number:focus {
      border-right-width: 0px !important;
    }
    .ant-input-number-input {
      font-size: 12px;
      // @apply bg-gray-50;
      &::-webkit-input-placeholder {
        // @apply pl-4;
      }
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
    .btn-price-range {
      height: 36px;
      font-size: 12px;
      border-radius: 6px;
      box-shadow: none;
      text-shadow: none;
      // right: -1px;
      // position: absolute;
      // @apply absolute text-mwblue-light bg-mwblue-lighter border-mwblue-lighter;
    }
    .separator {
      margin: 0 8px;
    }
  }
  .ant-checkbox-wrapper {
    // font-size: 12px;
    padding-left: 0px;
    padding-right: 0px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1f2937;
    // @apply text-sm;
    .ant-checkbox + span {
      // @apply px-1;
    }
  }
}
</style>
